import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, CircularProgress } from "@mui/material";

const RiskTrend = () => {
  const [riskData, setRiskData] = useState([]);
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch the risk data from the API
    const fetchRiskData = async () => {
      setLoading(true);
      try {
        const response = await fetch("/api/explore/riskData");
        const data = await response.json();
        setRiskData(data);

        const extractedYears = Object.keys(data[0]).filter(
          (key) => key !== "Year"
        );
        setYears(extractedYears);
      } catch (error) {
        console.error("Error fetching risk data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRiskData();
  }, []);

  return (
    <div>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ marginBottom: '20px' }}>
          <Table sx={{ minWidth: 680 }} aria-label="Risk Trend table">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#003366", // Dark Blue background
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "0.9rem", // Smaller font size
                    padding: "10px 12px", // Less padding
                  }}
                >
                  Year
                </TableCell>
                {years.map((year) => (
                  <TableCell
                    key={year}
                    sx={{
                      backgroundColor: "#003366", // Dark Blue background
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "0.9rem", // Smaller font size
                      padding: "6px 12px", // Less padding
                    }}
                  >
                    {year}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {riskData.map((item) => (
                <TableRow key={item.Year} sx={{
                  backgroundColor:
                    item.Year === "Total Supply" || item.Year === "Total Stocks to Use Ratio (SUR)"
                      ? "rgba(2, 62, 235, 0.15)"
                      : "inherit",
                }}>
                  <TableCell
                    sx={{
                      padding: "6px 12px",
                      fontSize: "0.85rem",

                    }}
                  >
                    {item.Year}
                  </TableCell>
                  {years.map((year) => (
                    <TableCell key={year} sx={{ padding: "6px 12px", fontSize: "0.85rem" }}>
                      {item[year]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default RiskTrend;
